import { Box, Text } from '@asktia/tia-ui'
import ReactMarkdown from 'react-markdown'
import { useAmpliFeatureFlag } from 'src/AmplitudeExperimentProvider'
import { useHomeMarket } from 'src/hooks'
import { isMobile } from 'src/utils'

type HomeBannerProps = {
    text: string
    market: string | undefined
}

const HomeBanner = () => {
    const { homeMarket } = useHomeMarket()
    const homeBannerFlag = useAmpliFeatureFlag<HomeBannerProps>(
        'member-portal-banner',
        {
            default: 'control'
        }
    )

    /** EARLY_RETURN: Home banner is disabled */
    if (!homeBannerFlag.enabled) {
        return null
    }

    /** EARLY_RETURN: Home banner has no payload (bad config) */
    if (homeBannerFlag.type !== 'config') {
        return null
    }

    const homeBannerConfig = homeBannerFlag.payload

    /** EARLY_RETURN: Home banner has no text */
    if (!homeBannerConfig.text || homeBannerConfig.text.trim() === '') {
        return null
    }

    /** EARLY_RETURN: Home banner is not configured */
    const targetedHomeMarket = homeBannerConfig.market
    if (!targetedHomeMarket) {
        return null
    }

    if (targetedHomeMarket === '*') {
        /** INFO: Home banner is configured for all home markets */
    } else {
        /** EARLY_RETURN: Home banner is not configured for the current home market */
        const currentHomeMarket = (homeMarket?.name || 'unknown').trim()

        if (
            targetedHomeMarket.localeCompare(currentHomeMarket, undefined, {
                sensitivity: 'base'
            }) !== 0
        ) {
            return null
        }
    }

    return (
        <Box
            sx={{
                width: '100vw',
                backgroundColor: '#ef308d',
                textAlign: 'left',
                position: 'relative',
                left: '50%',
                right: '50%',
                marginLeft: '-50vw',
                marginRight: '-50vw',
                minHeight: '110px',
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: `${isMobile() ? '16px' : 0} 16px`
            }}
        >
            <Text
                sx={{
                    color: '#000',
                    fontSize: '18px',
                    margin: 0,
                    paddingLeft: `${isMobile() ? '30px' : '60px'}`,
                    paddingRight: `${isMobile() ? '30px' : '60px'}`
                }}
            >
                <ReactMarkdown children={homeBannerConfig.text}></ReactMarkdown>
            </Text>
        </Box>
    )
}

export { HomeBanner }
